// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /*   API: "http://localhost:3000/telollevo/api/v1/",
  BACKEND_BASE_URL: "http://localhost:3000", */
  /*   API: "http://ec2-18-222-238-242.us-east-2.compute.amazonaws.com:3000/telollevo/api/v1/",
  BACKEND_BASE_URL: "http://ec2-18-222-238-242.us-east-2.compute.amazonaws.com:3000", */
  API: "https://backend.telollevochile.cl:3000/telollevo/api/v1/",
  BACKEND_BASE_URL: "https://backend.telollevochile.cl:3000",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
